import { LAST_DAY, YEAR } from '../constants';
import { breaks } from '../screens/Program/constants';

export const isLiveCheck = (talkData, now) => {
  const { startTime: start, endTime: end } = talkData;
  if (start && end) {
    let parsedStart = new Date(`October ${LAST_DAY}, ${YEAR} ${start}:00 GMT+0200`);
    let parsedEnd = new Date(`October ${LAST_DAY}, ${YEAR} ${end}:00 GMT+0200`);
    if (talkData.trackInDay === 6 && talkData.order) {
      const timeframe = 13.3; // lightning talks
      const tmp = parsedStart;
      parsedStart = new Date(tmp.getTime() + (talkData.order - 1) * timeframe * 60000);
      parsedEnd = new Date(tmp.getTime() + talkData.order * timeframe * 60000);
    }
    if (now >= parsedStart && now < parsedEnd) {
      return true;
    }
  }
  return false;
};

export const isConferenceDayCheck = () => {
  const now = new Date();
  // October
  if (now.getDate() === LAST_DAY && now.getMonth() === 9) {
    return true;
  }
  return false;
};

function getNextBreak() {
  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const future = breaks
    .map(e => ({ ...e, minutes: +e.startTime.split(':')[0] * 60 + +e.startTime.split(':')[1] }))
    .filter(e => e.minutes >= currentMinutes || e.minutes + Number(e.duration) >= currentMinutes);
  return future?.[0]?.startTime || null;
}

export const handleShowLive = () => {
  let y = 0;
  let yOffset = 0;
  // live talk icon
  const element = document.querySelector('.pulse');
  let wrapper = element?.closest('.card-content'); // wrapping component
  if (wrapper) {
    yOffset = -120; // offset from navbar talks
  } else {
    // break
    const nextBreak = getNextBreak();
    if (nextBreak) {
      const els = document.querySelectorAll('.program-row-time');
      wrapper = Array.from(els).find(el => el.innerText === nextBreak);
      if (wrapper) {
        yOffset = -75; // offset from navbar breaks
      }
    }
  }
  y = wrapper?.getBoundingClientRect().top + window.scrollY + yOffset || 0; // if empty no scroll
  if (y) window.scrollTo({ top: y, behavior: 'smooth' });
};
